<template>
  <div class="relative">
    <button
      v-on-click-outside="() => (isMenuOpen = false)"
      data-cy="more-menu-button"
      class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-sm border hover:bg-blue-50"
      @click="toggleMenu"
    >
      <icon-base
        :icon="IconVerticalDots"
        height="24"
        width="24"
        :icon-color="UTIL_COLORS.DEFAULT"
      />
    </button>
    <div
      v-if="isMenuOpen"
      class="moreButtonList absolute right-0 -bottom-1 z-50 w-max translate-y-full transform cursor-pointer overflow-hidden rounded-sm bg-white shadow-lg"
    >
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

import { UTIL_COLORS } from "@/helpers/constants";

import IconVerticalDots from "@/components/icons/IconVerticalDots.vue";

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<style>
@reference "@/assets/tailwind.css";

.moreButtonList li {
  @apply max-w-xs truncate p-2 whitespace-nowrap hover:bg-gray-100;
}
</style>
